import { render, staticRenderFns } from "./FuseSearchBar.vue?vue&type=template&id=23a48b35&scoped=true&"
import script from "./FuseSearchBar.vue?vue&type=script&lang=js&"
export * from "./FuseSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./FuseSearchBar.vue?vue&type=style&index=0&id=23a48b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a48b35",
  null
  
)

export default component.exports